<div class="container p-5">


    <div class="mb-2">
        <img style="width:100%" src="assets/ourshowrooms_en.jpg">
    </div>


    <div class="row no-gutters store-block" *ngFor="let s of stores">

        <div class="col-md-3 col-sm-12">

            <H5 class="mt-sm-4" style="text-transform: capitalize;font-weight: 700;">{{s['title'+lang_suffix]}}</H5>
            <a href="">


                <img style="    width: 200px;" src='assets/location.png'>
                <div style="    width: 200px;" class="text-center"><a target="_blank" href="{{s.googlemap_link}}">Click to open location</a></div>
            </a>

        </div>
        <div class="col-md-3 col-sm-12">

            <h6 class="mt-sm-4" i18n="@@address">Address</h6>
            <div>
               {{s['address'+lang_suffix]}}
            </div>
        </div>

        <div class="col-md-3 col-sm-12">

        </div>

        <div class="col-md-3 col-sm-12">
            <h6 class="mt-sm-4" i18n="@@contactus">Contacts</h6>
            <ul style="list-style: none;margin: 0px;padding:0px;">
                <li><i class="fa fa-phone"></i> {{s.phone}}</li>
                <li><i class="fa fa-envelope"></i> info@alarabiya.com.kw</li>
                <li><i class="fa fa-clock-o"></i> {{s.working_hours}}<br>{{s['notes'+lang_suffix]}}</li>
            </ul>
        </div>

    </div>
</div>